import {ReactNode} from "react";
import {NavBar} from "./NavBar.tsx";
import {Footer} from "./Footer.tsx";


interface DashboardProp{
    children: ReactNode;
}

export const MainLaoyut = ({ children }: DashboardProp) => {
    return (
        <div className="main_layout">
            <NavBar/>

            <main >
                {children}
                <div className="preFooterSpacer"></div>
            </main>
            
            <Footer/>
            
        </div>


    
    );
};
